export const formatTemplate = (template = "", values = {}) => {
	if (typeof template !== "string") {
		return "";
	}

	return template.replace(/\{([^}]+)\}/g, (match, key) => {
		const cleanKey = key.trim();

		// Si la clé n'existe pas dans values → on garde {key}
		if (!Object.hasOwn(values, cleanKey)) {
			return match;
		}

		const value = values[cleanKey];

		// null ou undefined → chaîne vide
		if (value === null || value === undefined) {
			return "";
		}

		return String(value);
	});
};
